export const HEADER_SET_TITLE = 'HEADER_SET_TITLE';
export const HEADER_SET_HEIGHT = 'HEADER_SET_HEIGHT';
export const setHeaderTitle = (title) => ({
    type: HEADER_SET_TITLE,
    payload: title,
});
export const setHeaderHeight = (height) => ({
    type: HEADER_SET_HEIGHT,
    payload: height,
});
